import React from "react";
import "./styles.scss";
import {
  igemLogoLight,
  iconIg,
  iconTw,
  iconFb,
  iconSl,
} from "../../assets/icons";

export const Footer = (): JSX.Element => (
  <div className="footer">
    <div className="footer-info">
      <div>
        <img src={igemLogoLight} alt="igem-logo" />
      </div>
      <div>
        <h6>iGEM Foundation</h6>
        <p>
          The International Genetically Engineered Machine (iGEM) Foundation is
          an independent, non-profit organization dedicated to the advancement
          of synthetic biology, education and competition, and the development
          of an open community and collaboration. Visit us at{" "}
          <a href="https://igem.org" target="_blank" rel="noreferrer">
            igem.org
          </a>
        </p>
      </div>
    </div>
    <div className="footer-contact">
      <div className="footer-contact-info">
        <h6>Contact us</h6>
        <p>hq@igem.org</p>
        <p>45 Prospect Street Cambridge, MA 02139</p>
        <p>
          Due to COVID-19, iGEM staff are working remotely and cannot receive
          phone calls. Please <a href="mailto:hq@igem.org">contact us</a> by
          email.
        </p>
        <p>
          You can read about our{" "}
          <a
            href="https://igem.org/Privacy_Policy"
            target="_blank"
            rel="noreferrer"
          >
            privacy policy here
          </a>
          .
        </p>
      </div>
      <div className="footer-contact-socials">
        <div>
          <h6 className="footer-contact-socials-title">Keep in touch!</h6>
          <div className="footer-contact-socials-icons">
            <a
              href="https://www.instagram.com/igem_hq/"
              target="_blank"
              rel="noreferrer"
            >
              <img src={iconIg} alt="icon-instagram" />
            </a>
            <a href="https://twitter.com/igem" target="_blank" rel="noreferrer">
              <img src={iconTw} alt="icon-twitter" />
            </a>
            <a
              href="https://www.facebook.com/iGEMFoundation/"
              target="_blank"
              rel="noreferrer"
            >
              <img src={iconFb} alt="icon-facebook" />
            </a>
            <a
              href="https://join.slack.com/t/igem2021global/shared_invite/zt-nm7q5pet-onh1OhigrujAUKfX4lDWLg"
              target="_blank"
              rel="noreferrer"
            >
              <img src={iconSl} alt="icon-slack" />
            </a>
          </div>
        </div>
        <div>
          <h6 className="footer-contact-socials-title">
            Stay up to date with our newsletter
          </h6>
          <a
            href="https://confirmsubscription.com/h/i/F2D48D61C2EA742F"
            target="_blank"
            rel="noreferrer"
          >
            <button type="button" className="footer-button">
              <h6>Subscribe</h6>
            </button>
          </a>
        </div>
      </div>
    </div>
  </div>
);
